/**
 * Paleta semântica de status usada no Kanban e indicadores de sessão.
 *
 * Consumimos tokens do design system (navy, gold, success, error) ao invés de
 * hex hardcoded para respeitar DS-TOKEN-02 e permitir dark mode consistente.
 */
export type StatusKey = 'in_progress' | 'waiting' | 'completed' | 'cancelled'

export const STATUS_COLORS: Record<
  StatusKey,
  {
    dot: string
    activeBg: string
    activeBorder: string
    text: string
    glow: string
  }
> = {
  in_progress: {
    dot: 'bg-navy-600',
    activeBg: 'bg-navy-50 dark:bg-navy-900/20',
    activeBorder: 'border-navy-200 dark:border-navy-800',
    text: 'text-navy-700 dark:text-navy-300',
    glow: 'group-hover:shadow-navy',
  },
  waiting: {
    dot: 'bg-gold-500',
    activeBg: 'bg-gold-50 dark:bg-gold-900/20',
    activeBorder: 'border-gold-200 dark:border-gold-800',
    text: 'text-gold-700 dark:text-gold-300',
    glow: 'group-hover:shadow-gold',
  },
  completed: {
    dot: 'bg-success-500',
    activeBg: 'bg-success-50 dark:bg-success-900/20',
    activeBorder: 'border-success-200 dark:border-success-800',
    text: 'text-success-700 dark:text-success-300',
    glow: 'group-hover:shadow-md',
  },
  cancelled: {
    dot: 'bg-error-500',
    activeBg: 'bg-error-50 dark:bg-error-900/20',
    activeBorder: 'border-error-200 dark:border-error-800',
    text: 'text-error-700 dark:text-error-300',
    glow: 'group-hover:shadow-md',
  },
}

export const STATUS_LABELS: Record<StatusKey, string> = {
  in_progress: 'Em andamento',
  waiting: 'Aguardando',
  completed: 'Concluído',
  cancelled: 'Cancelado',
}

export const HOME_ICON_PATH = '/images/logo/home-icon.png'
